import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ProvedorAuth, useAuth } from './auth';
import { Carregando } from './componentes/base';
import Layout from './componentes/Layout';
import Dashboard from './paginas/Dashboard';
import FolhaMensal from './paginas/FolhaMensal';
import Funcionarios from './paginas/Funcionarios';
import Login from './paginas/Login';
import Privacidade from './paginas/Privacidade';
import RegistoHoras from './paginas/RegistoHoras';
import './index.css';

function Rotas() {
  const { utilizador, aCarregar } = useAuth();

  // Wait for the session check before deciding, or a page refresh would bounce
  // an authenticated user to the login screen.
  if (aCarregar) {
    return <div className="flex min-h-screen items-center justify-center"><Carregando /></div>;
  }

  // A privacidade fica acessível sem sessão: quem é contado tem de a poder
  // ler sem ter de entrar primeiro.
  if (!utilizador) {
    return (
      <Routes>
        <Route path="/privacidade" element={<Privacidade />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="funcionarios" element={<Funcionarios />} />
        <Route path="registo-horas" element={<RegistoHoras />} />
        <Route path="folha-mensal" element={<FolhaMensal />} />
        <Route path="privacidade" element={<Privacidade />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ProvedorAuth>
        <Rotas />
      </ProvedorAuth>
    </BrowserRouter>
  </StrictMode>,
);
